<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Uploading Custom Files</h1>
      <p>
        One of the main ways that you can interact with your projects is by uploading custom CSV files to populate it.
        This allows you to quickly and easily fill your data without having to manually add each entry.
      </p>

      <p>
        To upload a CSV file with KPI/PSI values, <b>you can click one of either buttons</b> of the upload section of the
        <b>navigation bar.</b>
      </p>
      <div class="text-center mt-4">
        [Image Placeholder: Screenshot of KPI upload button and dialog]
      </div>

      <p class="mt-3">
        In there you'll be able to upload your file into the USE database. If anything goes wrong with your file, you
        will most likely be informed about it, before you upload it. The main cause of that is faulty headers. If one
        or more headers of your CSV file are faulty, you'll be able to know which ones they are with a small informative
        window in the upload dialog.
      </p>

      <div class="text-center mt-4">
        [Image Placeholder: Screenshot of KPI/PSI upload dialog warning]
      </div>

      <p class="mt-3">
        Once your file is uploaded, you can load them into your project. Refer to <b>Load KPIs/PSIs List Into Project</b>
        section to see how to load them.
      </p>
    </div>
  </div>
</template>

<script setup>

</script>


<style scoped>

</style>